"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var each_1 = require("./each");
/**
 * 删除 URL 上的参数
 *
 * @param {(string | string[])} name 需要删除的参数名集合
 * @param {string} [url=location.href] 需要删除参数的链接，默认为当前链接
 * @returns {string} 删除后的链接
 */
function delParam(name, url /* istanbul ignore next */) {
    if (url === void 0) { url /* istanbul ignore next */ = location.href; }
    if (!(name instanceof Array)) {
        name = [name];
    }
    url = url.replace(/[\r\n]/g, '');
    each_1.default(name, function (v) {
        url = url.replace(new RegExp('(?:&' + v + '=[^&]*)', 'g'), '');
        url = url.replace(new RegExp('(?:\\?' + v + '=[^&]*&?)', 'g'), '?');
    });
    return url;
}
exports.default = delParam;
//# sourceMappingURL=del-param.js.map